import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from '_atoms';
import { PromotionRequestsTable } from '_organisms';
import { getPromotionRequestsOnDashboardHRPR } from 'actions';
import './style.scss';

const TAB_PROMOTION_REQUESTS = 'promotion-requests';

export const DashboardHRPR = () => {
  const { t } = useTranslation();
  const tabs = [{ key: TAB_PROMOTION_REQUESTS, label: t('translation:job_promotion_requests_tab.title') }];
  const [tab, setTab] = useState(TAB_PROMOTION_REQUESTS);

  return (
    <div className="dashboard-hrpr">
      <Tabs className="dashboard-hrpr__tabs" activeTab={tab} onChange={setTab} tabs={tabs} />
      {tab === TAB_PROMOTION_REQUESTS && (
        <PromotionRequestsTable
          fetchRequests={getPromotionRequestsOnDashboardHRPR}
          cardTitle={t('translation:job_promotion_requests_tab.title')}
        />
      )}
    </div>
  );
};
